import {XhrRequest} from './XhrRequest';
import each from 'lodash/each';

export class PostRequest extends XhrRequest {

    constructor (useFormDataContentType) {
        super();

        this.useFormDataContentType = !!useFormDataContentType;
    }

    post (path, postBody) {
        let headers;
        let requestBody;
        const token = window.localStorage.getItem('loginToken::operator');
        const clientId = window.localStorage.getItem('clientId::operator');

        if (this.useFormDataContentType) {
            headers = {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            };
            requestBody = postBody;
        }
        else {
            headers = {
                'Content-Type': 'application/json; charset=utf-8'
            };
            requestBody = JSON.stringify(postBody);
        }

        if (token) {
            headers[ 'Authorization' ] = 'UMS-TOKEN ' + token;
        }

        if (clientId) {
            headers[ 'ClientId' ] = clientId;
        }

        return fetch(path, {
            method: 'post',
            headers: headers,
            body: requestBody
        })
            .then((res) => {
                if (res && !this.useFormDataContentType) {
                    return res.json();
                }
            });
    }
}

